import { render, staticRenderFns } from "./AdminOrdersHistory.vue?vue&type=template&id=339822a8&scoped=true&"
import script from "./AdminOrdersHistory.vue?vue&type=script&lang=js&"
export * from "./AdminOrdersHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrdersHistory.vue?vue&type=style&index=0&id=339822a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339822a8",
  null
  
)

export default component.exports